import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { NavParams, ModalController } from '@ionic/angular';
import { FirebaseService } from '../_services/firebase.service';
import { AuthService } from '../_services/auth.service';
import { ToastService } from '../_services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { ServerService } from '../_services/server.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-simulation-peers-reschedule',
  templateUrl: './simulation-peers-reschedule.page.html',
  styleUrls: ['./simulation-peers-reschedule.page.scss'],
})
export class SimulationPeersReschedulePage implements OnInit {

  message = 'Hi, unfortunately I will not be available in the scheduled time. I can suggest these dates instead';
  newMessage = 'Hi, unfortunately I will not be available on the dates proposed to reschedule the simulation, but I suggest you new dates';
  today = moment().format('YYYY-MM-DD');

  newDate1;
  newDate2;
  newDate3;
  newDate4;

  simulation;
  user;

  updating = false;
  toastMessage = 'An email has been sent to your peer to reschedule the simulation.';

  p2pId;

  showCalendars = true;
  datesSelected = false;

  showError = false;
  errorMessage = 'There was an error submitting the request please try again';

  hasToAcceptReschedule = false;
  showNewProposals = false;
  possibleRescheduleDates = [];
  newDateSelected;

  peerName;

  companyTimezone;

  dates = [];

  isWeekday;
  hourValues = '8,9,10,11,12,13,14,15,16,17,18,19,20,21'
  minuteValues = '0,15,30,45'

  constructor(public navParams: NavParams,
    private firebaseService: FirebaseService,
    private authService: AuthService,
    private toastService: ToastService,
    public modalCtrl: ModalController,
    public translate: TranslateService,
    private serverService: ServerService,
    private route: ActivatedRoute) { }

  async ngOnInit() {
    this.user = await this.authService.getUser();

    this.isWeekday = (dateString: string) => {
      const date = new Date(dateString);
      const utcDay = date.getUTCDay();
      return utcDay !== 0 && utcDay !== 6;
    };

    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.p2pId = params['id'];
        this.firebaseService.getDocument(`/user_scheduled_simulations/${this.user.uid}/${this.p2pId}`).then((res: any) => {
          this.hasToAcceptReschedule = res.reschedule.hasToAccept;
          if (this.hasToAcceptReschedule) {
            this.message = res.reschedule.message;
            this.possibleRescheduleDates = res.reschedule.dates.split(',');
            this.dates = [];
            this.possibleRescheduleDates = this.possibleRescheduleDates.map(date => {
              let disabledDate;
              if(date < this.today) disabledDate = true;
              else disabledDate = false;
              return date = {
                value: date,
                string: this.formatDate(date),
                disabled: disabledDate
              }
            });
          } else {
            this.dates = [this.simulation.p2p_date, this.simulation.p2p_date]
          }
        })
      } else {
        this.dates = [this.simulation.p2p_date, this.simulation.p2p_date]
      }
    });

    if (this.navParams.data.simulation) this.simulation = this.navParams.data.simulation;

    if(this.simulation.reschedule) {
      this.hasToAcceptReschedule = this.simulation.reschedule.hasToAccept;
      if (this.hasToAcceptReschedule) {
        this.message = this.simulation.reschedule.message;
        this.possibleRescheduleDates = this.simulation.reschedule.dates.split(',');
        this.dates = [];
        this.possibleRescheduleDates = this.possibleRescheduleDates.map(date => {
          let disabledDate;
          if(date < this.today) disabledDate = true;
          else disabledDate = false;
          return date = {
            value: date,
            string: this.formatDate(date),
            disabled: disabledDate
          }
        });
      } else {
        if (this.simulation.reschedule.dates) this.dates = this.simulation.reschedule.dates.split(',');
         else this.dates = [this.simulation.p2p_date, this.simulation.p2p_date]
      }
    }

    this.firebaseService.getDocument(`/users/${this.simulation.peerId}/firstName`).then(name => {
      this.peerName = name
      this.translations();
    })
    this.firebaseService.getDocument(`/companies/${this.user.companyId}/timezone`).then(timezone => {
      this.companyTimezone = timezone
    })
  }

  formatDate(date: string): string {
    // Default to English format if language is not recognized
    const language = this.translate.currentLang;

    let dateFormat = 'dddd, MMMM Do [at] h:mm A';
    if (language === 'es') {
      dateFormat = 'dddd, DD [de] MMMM [a las] HH:mm [hs]';
    }
    return moment(date).locale(language).format(dateFormat);
  }

  sendRescheduleDates() {
    if (this.dates[0] != '' && this.dates[1] != '') this.datesSelected = true;
    else return;

    this.updating = true;
    this.dates = this.dates.filter(d => {
      if(d) return d;
    });

    this.dates = this.filtrarArray(this.dates)

    let reschedule: any = {
      reschedule: {
        message: this.message,
        dates: this.dates.toString()
      }
    }

    if (this.showNewProposals) reschedule.reschedule.message = this.newMessage

    this.firebaseService.updateDocument(`/user_scheduled_simulations/${this.user.uid}`, this.simulation.key,
      reschedule).then(res => {
        reschedule.reschedule.hasToAccept = true;
        this.firebaseService.updateDocument(`/user_scheduled_simulations/${this.simulation.peerId}`, this.simulation.key,
          reschedule).then(res => {
            let data: any = {
              participant1: this.user.uid,
              participant2: this.simulation.peerId,
              p2p_id: this.simulation.key,
              message: this.message,
              date: moment(this.simulation.p2p_date).utcOffset(this.companyTimezone).format('YYYY-MM-DDTHH:mm:00Z'),
              new_date1: moment(this.dates[0]).utcOffset(this.companyTimezone).format('YYYY-MM-DDTHH:mm:00Z'),
              new_date2: moment(this.dates[1]).utcOffset(this.companyTimezone).format('YYYY-MM-DDTHH:mm:00Z'),
              description: true,
            }

            if (this.simulation.reschedule && this.simulation.reschedule.hasToAccept) data.description = false;

            if (this.showNewProposals) data.message = this.newMessage;

            this.serverService.sendEmailRescheduleSimulation(data).subscribe(res => {
              this.updating = false;

              this.modalCtrl.dismiss({data: this.dates});
              this.toastService.present(this.toastMessage, 4000, 'bottom', 'checkmark-circle-outline', 'popup-slide')
            })
          }).catch(error => {
            console.error(error)
            this.showError = true;
            this.updating = false;
          })
        }).catch(error => {
          console.error(error)

          this.showError = true;
          this.updating = false;
      })

  }

  translations() {
    this.errorMessage = this.translate.instant(this.errorMessage);
    this.message = this.translate.instant(this.message, {X: this.peerName});
    this.newMessage = this.translate.instant(this.newMessage, {X: this.peerName});
  }

  newDate() {
    this.showCalendars = false;
  }

  deleteDate(index: number) {
    this.dates.splice(index, 1)
  }

  proposeNewDates(event) {
    let value = event.detail.value;

    if (value === 'propose') {
      this.newDateSelected = '';
      this.showNewProposals = true;
      this.dates = [this.simulation.p2p_date, this.simulation.p2p_date];
    } else {
      this.newDateSelected = value;
      this.showNewProposals = false;
      this.showCalendars = true;
      this.dates = [];
    }
  }

  confirmNewDate() {
    this.updating = true;
    let toastMessage = 'Peers simulation has been modified successfully';
    let data = {
      participant1: this.user.uid,
      participant2: this.simulation.peerId,
      date: this.newDateSelected,
      module: this.simulation.module,
    }

    this.firebaseService.updateDocument(`/user_scheduled_simulations/${this.simulation.peerId}`, this.simulation.key, {rescheduled: true}).then(x => {
      this.firebaseService.updateDocument(`/user_scheduled_simulations/${this.user.uid}`, this.simulation.key, {rescheduled: true}).then(x => {
        this.serverService.matchUserP2Psimulation(data).subscribe(x => {
          this.toastService.present(toastMessage, 4000, 'bottom', 'checkmark-circle-outline', 'popup-slide');
          this.modalCtrl.dismiss();
          this.updating = false;
        });
      }).catch(error => {
        console.error(error)

        this.showError = true;
        this.updating = false;
      })
    }).catch(error => {
      console.error(error)

      this.showError = true;
      this.updating = false;
    })
  }

  filtrarArray(array) {
    let result = array.filter( (value, index, self) => {
      let firstDate = self.findIndex( date => {
        return date === value
      });
      return index === firstDate;
    });
    return result;
  }

}
